import React from 'react';

export const Footer = () => (
  <footer className="text-center p-2">
    &copy; Universidad Autónoma Latinoamericana
    {' '}
    {new Date().getFullYear()}
  </footer>
);
